const { getAxiosInstance } = require('../connection');

module.exports = {
    DynamicFilter: function (abortController, filterObject, offset, limit, searchValues, sortColumn, sortDirection, infiteLoaderType, sortObject, singleTable, excel, excelObject) {
        return getAxiosInstance({
            url:  '/report/filter',
            signal: abortController.signal,
            method: 'POST',
            json: true,
            data: {
                filter: filterObject,
                offset: offset,
                limit: limit,
                searchValues: searchValues,
                sortColumn: sortColumn,
                sortDirection: sortDirection,
                infiteLoaderType: infiteLoaderType,
                sortObject: sortObject,
                singleTable: singleTable,
                excel: excel,
                excelSettings: excelObject,
            },
        }).then((r) => r.data);
    },
    DynamicFilterExcel: function (filterObject, offset, limit, searchValues, sortColumn, sortDirection, infiteLoaderType, sortObject, singleTable, excel, excelObject) {
        return getAxiosInstance({
            url:  '/report/filter',
            method: 'POST',
            responseType: 'blob',
            data: {
                filter: filterObject,
                offset: offset,
                limit: limit,
                searchValues: searchValues,
                sortColumn: sortColumn,
                sortDirection: sortDirection,
                infiteLoaderType: infiteLoaderType,
                sortObject: sortObject,
                singleTable: singleTable,
                excel: excel,
                excelSettings: excelObject,
            },
        }).then((r) => r.data);
    },

    ConversionFilter: function (timeFilter, filterList) {
        return getAxiosInstance({
            url:  '/report/conversion',
            method: 'POST',
            json: true,
            data: {
                filterList: filterList,
                timeFilter: timeFilter,
            },
        }).then((r) => r.data);
    },

    OpenDeals: function () {
        return getAxiosInstance({
            url:  '/report/open_deals',
            method: 'GET',
        }).then((r) => r.data);
    },

    FilterSettings: function () {
        return getAxiosInstance({
            url:  '/report/filtersettings',
            method: 'GET',
        }).then((r) => r.data);
    },
    EventOfUser: function (userId) {
        return getAxiosInstance({
            url:  '/report/detail/user/event-user',
            method: 'POST',
            json: true,
            data: {
                userId: userId,
            },
        }).then((r) => r.data);
    },
    EventById: function (eventId) {
        return getAxiosInstance({
            url:  '/report/detail/user/event-id/' + encodeURIComponent(eventId),
            method: 'GET',
            json: true,
        }).then((r) => r.data);
    },
    EventByTimePeriod: function (beginDate = '', endDate = '', filter = '') {
        return getAxiosInstance({
            url:  '/report/conversion/event/detail-timeperiod',
            method: 'POST',
            json: true,
            data: {
                beginDate: beginDate,
                endDate: endDate,
                filter: filter,
            },
        }).then((r) => r.data);
    },
    EventMetaTagOptions: function () {
        return getAxiosInstance({
            url:  '/report/conversion/event/detail-timeperiod',
            method: 'GET',
            json: true,
        }).then((r) => r.data);
    },
    EventData: function (eventId) {
        return getAxiosInstance({
            url:  '/report/detail/event/data/' + encodeURIComponent(eventId),
            method: 'GET',
            json: true,
        }).then((r) => r.data);
    },
    userActivity: (eventId, enrichmentId) => {
        let params = [];
        if (enrichmentId) {
            params.push(`enrichment_id=${encodeURIComponent(enrichmentId)}`);
        }
        return getAxiosInstance({
            url: `/events/${encodeURIComponent(eventId)}/reports/activity?${params.join('&')}`,
            method: 'get',
            json: true,
        }).then((r) => r.data);
    },
};
